//
// Create Base URL 'API'
//

const baseURL = 'http://api.bibitrade.com/api/v1/'; 

export default {
    baseURL,
};
